import { ReactNode } from "react";
import { Box, useTheme } from "@mui/material";
import { useAppNavDrawer } from "~/providers/app-nav-drawer";
import { useColorMode } from "~/providers/color-mode";

export type TriageToolbarWrapperProps = {
  children: ReactNode;
};

export function TriageToolbarWrapper({ children }: TriageToolbarWrapperProps) {
  const navDrawer = useAppNavDrawer();
  const theme = useTheme();
  const { mode } = useColorMode();

  return (
    <Box
      role="toolbar"
      sx={{
        position: "fixed",
        bottom: 0,
        right: (theme) => theme.spacing(3),
        left: `calc(${navDrawer.width} + ${theme.spacing(3)})`,
        transition: (theme) =>
          theme.transitions.create("left", navDrawer.transition),
        zIndex: (theme) => theme.zIndex.drawer,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "primary.darker",
          py: 2,
          px: 5,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "primary.main",
          boxShadow: (theme) =>
            mode === "light"
              ? `0 0 20px 0 ${theme.palette.background.lightest}`
              : "0 0 24px rgba(0,0,0,0.5)",
          mx: "auto",
          borderBottom: "none",
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,

          ".MuiButton-root": {
            ml: 2,
            py: 1,
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
